import { useGetRenewVisaDocumentList } from "@/api/services/main/renew-visa";
import { RENEW_VISA_FILTER } from "@/features/renew-visa/constants/renewVisaFilter";
import { toNumber } from "@/utils/number";

type UseGetRenewVisaUnderReviewAndApprovedQuantityReturn = {
  quantity: number;
};
export const useGetRenewVisaUnderReviewAndApprovedQuantity = (): UseGetRenewVisaUnderReviewAndApprovedQuantityReturn => {
  const { data } = useGetRenewVisaDocumentList({
    status: RENEW_VISA_FILTER.UNDER_REVIEW_AND_APPROVED.status,
  });

  return {
    quantity: toNumber(data?.pagination.total),
  };
};
